import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FootballMatchTable from 'modules/Football/components/FootballMatchTable';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { loadByMatch, isLoadingByMatch, get, hasMatchCompetition } from '../reducers/leagueTable';

@standardAsyncConnect([
  {
    dispatch: ({state, params: {matchId}}) => loadByMatch(state, matchId),
    preventResolve: ({state, params: {matchId}}) => isLoadingByMatch(state, matchId) || !hasMatchCompetition(state, matchId),
    state: (state, ownProps) => {
      const tableState = get(state, ownProps.params.matchId) || {},
            matchState = state.football.match[ownProps.params.matchId] || {};
      return {
        error: (tableState.error || matchState.error || {}).error,
        tables: tableState.tables,
        match: matchState.match
      };
    }
  }
])
@catchLifeCycleErrors
export default class FootballMatchTableContainer extends Component {
  static propTypes = {
    error: PropTypes.string,
    tables: PropTypes.object,
    matchLabel: PropTypes.string,
    match: PropTypes.object
  }
  render() {
    return this.props.error
         ? <p className="error">We are currently unable to show the table.</p>
         : <FootballMatchTable match={this.props.match} tables={this.props.tables} matchLabel={this.props.matchLabel}/>
    ;
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMatchTableContainer.js